import React from "react";
import { createTrackingUtils } from "utils/experiments";
import useUserAgent from "hooks/useUserAgent";

export const trackCheckInMarketingCarrier = createTrackingUtils({
  defaultStage: 1,
  name: "flights_pb_universal_checkin_marketing_carrier",
  stages: {
    AFFECTED_USERS: 1,
    CHECKIN_PAGE_WEB_AND_APPS: 2,
    CHECKIN_PAGE_DESKTOP: 3,
    CHECKIN_PAGE_MDOT: 4,
    CHECKIN_PAGE_IOS: 5,
    CHECKIN_PAGE_ANDROID: 6
  },
  goals: {
    FLIGHTS_WEB_APPS_HC_CLICK: 1,
    CHECKIN_VIA_AIRLINE_WEBSITE_CLICK: 2
  },
  goalsWithValue: []
});

export const useTrackCheckInMarketingCarrier = () => {
  const { isMobile } = useUserAgent();

  React.useEffect(() => {
    trackCheckInMarketingCarrier.stages.CHECKIN_PAGE_WEB_AND_APPS();

    if (isMobile) {
      trackCheckInMarketingCarrier.stages.CHECKIN_PAGE_MDOT();
    } else {
      trackCheckInMarketingCarrier.stages.CHECKIN_PAGE_DESKTOP();
    }
  }, [isMobile]);
};
